module.exports = __webpack_public_path__ + "2cc6f0ef9c3857857e8089a2dc2699c5.svg";